import { useState } from 'react';
import { useDebounce } from 'use-debounce';
import { useTranslation } from 'react-i18next';

import { useUsersSearch } from 'legacy/search/hooks';
import SearchDropdown from './SearchDropdown';

function formatUserOption(data) {
  return { ...data, label: data?.name, id: data?._id };
}

const UsersSearch = ({
  label,
  field,
  placeholder,
  onChange,
  selectedUsers = [],
  associationId,
  ...selectProps
}) => {
  const { t } = useTranslation('events');
  const [searchText, setSearchText] = useState<string>('');
  const [debouncedInput] = useDebounce(searchText, 200);
  const { data: users, isLoading } = useUsersSearch(debouncedInput, associationId);

  const onSelectChange = (selected) => {
    onChange(selected);
    setSearchText('');
  };

  return (
    <SearchDropdown
      id={`${field}-dropdown`}
      data={users}
      isLoading={isLoading}
      label={label}
      noOptionsMessage={() => t('userSearch.noUsersFound')}
      onChange={onSelectChange}
      onInputChange={setSearchText}
      optionDataFormatter={formatUserOption}
      placeholder={placeholder}
      selectedUsers={selectedUsers}
      value={searchText}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...selectProps}
    />
  );
};

export default UsersSearch;
